
import { RouteObject } from 'react-router-dom';
import HomePage from '../pages/home/page';
import AboutPage from '../pages/about/page';
import VenturesPage from '../pages/ventures/page';
import ExperiencePage from '../pages/experience/page';
import WritingPage from '../pages/writing/page';
import SpeakingPage from '../pages/speaking/page';
import ContactPage from '../pages/contact/page';
import TermsPage from '../pages/terms/page';
import PrivacyPage from '../pages/privacy/page';
import NotFound from '../pages/NotFound';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />
  },
  {
    path: '/about',
    element: <AboutPage />
  },
  {
    path: '/ventures',
    element: <VenturesPage />
  },
  {
    path: '/experience',
    element: <ExperiencePage />
  },
  {
    path: '/writing',
    element: <WritingPage />
  },
  {
    path: '/speaking',
    element: <SpeakingPage />
  },
  {
    path: '/contact',
    element: <ContactPage />
  },
  {
    path: '/terms',
    element: <TermsPage />
  },
  {
    path: '/privacy',
    element: <PrivacyPage />
  },
  {
    path: '*',
    element: <NotFound />
  }
];

export default routes;
